import { useOnboardingLoginRedirection } from '@modules/onboarding/hooks/useOnboardingLoginRedirection';
import { PaymentPageLoader } from '@shared/components/PaymentPage/PaymentPageLoader';

export const RedirectionLoader = () => {
    useOnboardingLoginRedirection();

    return <PaymentPageLoader />;
};
